import { useEffect, useContext, useState } from "react";
import { HorizonChartConfig } from "./HorizonChartConfig";
import { StoreContext } from "../../../store/Store";
import { LocalStoreContext } from "../store/LocalStore";
import { applyOverrides } from "../../../utils/dataFunctions";
import { config as horizonChartConfig } from "../../../d3charts/spider/config";
import { actionTypes as lactionTypes } from "../store/storeTypes";
import { Loader } from "../../../components/loader/Loader";
// import sdata from "../../../data/Spider2.json";
// import {}

export const HorizonSpider = () => {
  const [store] = useContext(StoreContext);
  const [lstore, ldispatch] = useContext(LocalStoreContext);

  const { controlPopupMenu, defaultTicker } = store;
  const { horizon, loading } = lstore;
  const [horizonConfig, setHorizonConfig] = useState();

  useEffect(() => {
    if (
      horizon.rawdata.length > 0 &&
      "horizon" in controlPopupMenu.selected &&
      "spiderTicker" in controlPopupMenu.selected
    ) {
      const horizonConfig = applyOverrides(horizonChartConfig, {});
      setHorizonConfig(horizonConfig);

      const fdata = horizon.rawdata.filter((row) => {
        return (
          +row.Column_68 === +controlPopupMenu.selected["horizon"] &&
          row.Column_2 === controlPopupMenu.selected["spiderTicker"]
        );
      })[0];

      const data = { data: [], features: {}, legend: [], header: "" };

      const headerArray = Object.values(fdata)
        .filter((_, i) => i === 2 || i === 54 || i === 68)
        .map((val) => val);

      data.header = `${headerArray[0] ? headerArray[0] : "NA"} V-Score for ${
        headerArray[2]
      }d Horizon = ${headerArray[1] ? headerArray[1] : "NA"}`;

      data.features["0"] = Object.entries(fdata)
        .filter((_, i) => i >= 6 && i <= 18)
        .map((item) => item[0]);
      data.features["1"] = Object.entries(fdata)
        .filter((_, i) => i >= 21 && i <= 33)
        .map((item) => item[0]);
      data.features["2"] = Object.entries(fdata)
        .filter((_, i) => i >= 37 && i <= 49)
        .map((item) => item[0]);

      data.legend.push(
        Object.values(fdata)
          .filter((_, i) => i >= 2 && i <= 3)
          .map((val) => val)
          .reverse()
      );
      data.legend.push(
        Object.values(fdata)
          .filter((_, i) => i >= 19 && i <= 20)
          .map((val) => val)
      );
      data.legend.push(
        Object.values(fdata)
          .filter((_, i) => i >= 35 && i <= 36)
          .map((val) => val)
      );

      data.data = [
        Object.entries(fdata)
          .filter((_, i) => i >= 6 && i <= 18)
          .reduce((res, b) => {
            return { ...res, [b[0]]: b[1] };
          }, {}),
        Object.entries(fdata)
          .filter((_, i) => i >= 21 && i <= 33)
          .reduce((res, b) => {
            return { ...res, [b[0]]: b[1] };
          }, {}),
        Object.entries(fdata)
          .filter((_, i) => i >= 37 && i <= 49)
          .reduce((res, b) => {
            return { ...res, [b[0]]: b[1] };
          }, {}),
      ];

      ldispatch({ type: lactionTypes.SET_HORIZON_FILTERED, payload: data });
    }
  }, [
    horizon,
    controlPopupMenu.label,
    controlPopupMenu.selected,
    ldispatch,
    defaultTicker,
  ]);

  if (loading) {
    return (
      <div
        className="popup"
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader />
      </div>
    );
  }

  if (!loading && (!horizon.rawdata || horizon.rawdata.length === 0)) {
    return (
      <div
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#666",
          fontSize: 14,
        }}
      >
        No data available
      </div>
    );
  }

  return horizonConfig ? (
    <HorizonChartConfig config={horizonConfig} />
  ) : (
    <div
      className="popup"
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loader />
    </div>
  );
};
